import React, { useRef, useEffect } from "react";
import myVideo from './measurementVideo.mp4';

const MeasurementVideoPage = (props) => {
  const videoRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    videoRef.current.src = myVideo;
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", margin: '10px 0px 30px 0px'}}>
        Measurement
        </div>

        <div style={{width: '90%', border: '1px solid #888'}}>
          <video ref={videoRef} controls width={'100%'} height={'auto'} />
        </div>
    </div>
  )
}

export default MeasurementVideoPage;